[
  {
    "code": "ST-P",
    "name": "Príncipe"
  },
  {
    "code": "ST-S",
    "name": "São Tomé"
  }
]